import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'

import Modal from '@components/modal/modal'
import axios from 'axios'

import Checkbox from '../shared/checkbox'
import TextInput from '../shared/text_input'
import Textarea from '../shared/textarea'
import GoogleRecaptcha from "react-google-recaptcha";

import { inputLabelsMap, errorsMap, formTitleMap } from './form_utils'

const ShortContactForm = ({ place = 'it_glossary', title }) => {
  const [form, setForm] = useState({
    fullname: '',
    company: '',
    email: '',
    message: '',
    place: place,
  })

  const [sendSuccess, setSendSuccess] = useState('')
  const recaptchaRef = useRef();

  useEffect(() => {
    new Modal('rodo-modal').init()
  })

  const formSet = 'contact'

  const {
    control,
    register,
    errors,
    trigger
  } = useForm({ mode: 'onBlur' })

  const isDev = window.location.host !== 'railwaymen.org' && window.location.host !== 'rwm-stage.int.railwaymen.org'

  const submitValidForm = async (e) => {
    e.preventDefault()
    e.persist()

    const token = isDev ? 'dev' : await recaptchaRef?.current?.executeAsync();

    const url = '/contact/submit'
    const headers = {
      'X-CSRF-TOKEN': document.querySelector('[name=csrf-token]').content,
      'Accept': 'application/json'
    };

    token && axios.post(url, {
      contact: form,
      'g-recaptcha-response': token
    }, { headers: headers })
      .then((response) => {
        if (response.status == '200') {
          if (response.data.redirect) {
            window.location = response.data.redirect
          } else {
            setSendSuccess(true)
          }
        }
      }
      ).catch((error) => {
        console.error(error)
      })
  }

  const updateForm = val => {
    setForm({ ...form, ...val })
  }

  useEffect(() => {
    const parent = document.getElementById('short-contact-form')?.closest('form')?.parentNode;
    if (parent) parent.classList.add('loaded');
  }, []);

  return (
    <div id="short-contact-form">
      {title !== 'hidden' && (
          <h3 className="text-gradient-light" style={{
          fontSize: 28,
          lineHeight: 1.54,
          fontWeight: 600,
          marginBlockEnd: 22
        }}>
          {title || formTitleMap.default}
        </h3>
      )}
      {!sendSuccess &&
        <div className="form form-input-white">
          <div className="form-row">
            <TextInput
              id="contact-fullname"
              name="fullname"
              formSet={formSet}
              value={form.fullname}
              onChange={updateForm}
              formRef={register({ required: true })}
              errors={errors.contact}
              inputLabelsMap={inputLabelsMap}
              errorsMap={errorsMap}
            />
          </div>

          <div className="form-row">
            <TextInput
              id="contact-companyname"
              name="company"
              formSet={formSet}
              value={form.company}
              onChange={updateForm}
              formRef={register({ required: true })}
              errors={errors.contact}
              inputLabelsMap={inputLabelsMap}
              errorsMap={errorsMap}
            />
          </div>

          <div className="form-row">
            <TextInput
              id="contact-email"
              name="email"
              formSet={formSet}
              type="email"
              value={form.email}
              onChange={updateForm}
              formRef={register({ required: true, pattern: /^\S+@\S+$/i })}
              errors={errors.contact}
              inputLabelsMap={inputLabelsMap}
              errorsMap={errorsMap}
            />
          </div>

          <TextInput
            name="place"
            formSet={formSet}
            type="hidden"
            value={place}
          />

          <div className="form-row">
            <Textarea
              id="contact-message"
              name="message"
              formSet={formSet}
              value={form.message}
              onChange={updateForm}
              formRef={register({ required: true })}
              errors={errors.contact}
              inputLabelsMap={inputLabelsMap}
              errorsMap={errorsMap}
            />
          </div>

          <div className="form-row">
            <Checkbox
              id="contact-accept-current-processing"
              name="accept_current_processing"
              formSet={formSet}
              value={form.accept_current_processing}
              onChange={updateForm}
              formRef={register({ validate: val => val === true })}
              errors={errors.contact}
              inputLabelsMap={inputLabelsMap}
              errorsMap={errorsMap}
              size='small'
              labelClassName="dark"
            />
          </div>
          <div className="form-row">
            <Checkbox
              id="contact-accept-future-processing"
              name="accept_future_processing"
              formSet={formSet}
              value={form.accept_future_processing}
              onChange={updateForm}
              errors={errors.contact}
              inputLabelsMap={inputLabelsMap}
              errorsMap={errorsMap}
              size='small'
              labelClassName="dark"
            />
          </div>

          <div className="form-row" style={{ margin: "0 0 30px 0" }}>
            * - required
          </div>

          {!isDev && <GoogleRecaptcha
            ref={recaptchaRef}
            sitekey={process.env.RECAPTCHA_SITE_KEY}
            size="invisible"
            hl="en"
          />}

          <button
            className="btn gradient gradient-light"
            type="submit"
            onClick={submitValidForm}
          >
            Send
          </button>
        </div>
      }

      {sendSuccess &&
        <div className="message">
          <div className="message-content">
            <div>
              <h1>Thank you!</h1>
              <p>Thank you for your message, we will get back to you as soon as possible!</p>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default ShortContactForm